import React from "react";
import { createRoot } from "react-dom/client";
import AppWrapper from "./components/AppWrapper";
import LocalizationMessageProvider from "./components/LocalizationMessageProvider";
import { Amplify } from "aws-amplify";
import PortalRouter from "src/components/Router/PortalRouter";
import "@cloudscape-design/global-styles/index.css";
import "./logger";
import "./index.scss";
import { AuthProvider } from "src/hooks/useAuth";
import getAmplifyConfiguration from "src/utils/AmplifyConfigUtils";

Amplify.configure(getAmplifyConfiguration("beta"));

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <AppWrapper>
      <LocalizationMessageProvider>
        <AuthProvider>
          <PortalRouter />
        </AuthProvider>
      </LocalizationMessageProvider>
    </AppWrapper>
  </React.StrictMode>
);
